import { Grid2, Box, Button, Typography } from '@mui/material';
import CarouselComponent from './Carousel';
import AddIcon from '@mui/icons-material/Add';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { ScrollContainerWithHeader } from '../../shared/components/student/ScrollComponent';
import CustomDivider from '../../shared/utils/CustomDivider';
import { CircularButton } from '../../shared/utils/IconButton';
import { useNavigate } from 'react-router-dom';
import Memories from './Memories';
import EventSection from './EventSection';
import LingtBlueContainer, { DarkBlueContainer, } from '../../shared/utils/LingtBlueContainer';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Grid_Gap } from '../../shared/constants';
import { useCreditScore, useStudentCurrentOfflineCourse, useStudentCurrentOnlineCourse } from '../../assets/api/UseStudentGetApi';
import { SkeletonCom, TextSkeleton } from '../../shared/utils/SkeletonCom';
import CurrentClassCard from '../../shared/components/student/CurrentClassCard';
import { useToaster } from '../../shared/utils/ToasterProvider';


const StudentClasses = ({ courses, isLoading }) => {
  return (
    <ScrollContainerWithHeader boxShadow={"none"} customPadding={"none"}>
      {!isLoading && courses?.length > 0 && (
        courses.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, lg: 6 }} sx={{ flex: '0 0 auto', display: "flex", alignItems: "stretch" }}>
            <CurrentClassCard item={item} />
          </Grid2>
        ))
      )}

      {!isLoading && courses?.length === 0 && (
        <Typography variant="body1" sx={{ p: 2, textAlign: "center", width: "100%" }}>
          No class today.
        </Typography>
      )}

      {isLoading && (
        [...Array(1)].map((_, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, lg: 6 }} sx={{ flex: '0 0 auto', display: "flex", alignItems: "stretch" }}>
            <SkeletonCom />
          </Grid2>
        ))
      )}
    </ScrollContainerWithHeader>
  );
};



const Dashboard = () => {

  const { showToaster } = useToaster();
  const navigate = useNavigate();
  const { data: creditScore, isLoading: isCreditScoreLoading } = useCreditScore();
  const { data: studentCurrentOnlineCourses, isLoading: isOnlineCurrentCoursesLoading } = useStudentCurrentOnlineCourse({ is_event: 0 });
  const { data: studentCurrentOfflineCourses, isLoading: isofflineCurrentCoursesLoading } = useStudentCurrentOfflineCourse({ is_event: 0 });
  const isCourseLoading = isOnlineCurrentCoursesLoading && isofflineCurrentCoursesLoading
  const offline = Array.isArray(studentCurrentOfflineCourses?.data) ? studentCurrentOfflineCourses?.data : [];
  const online = Array.isArray(studentCurrentOnlineCourses?.data) ? studentCurrentOnlineCourses?.data : [];
  const allCourses = [...offline, ...online];



  return (
    <>

      <CustomDivider orientation='horizontal' />
      <Grid2 container sx={{ display: "flex", justifyContent: "flex-end" }}>
        <CircularButton icon={"weui:setting-outlined"} />
        <CircularButton icon={"iconamoon:notification"} onClick={() => {
          navigate("/student/notification");
        }} />
      </Grid2>
      <CustomDivider orientation='horizontal' />
      <Grid2 container spacing={Grid_Gap}>
        <Grid2 item size={{ md: 9, sm: 8, xs: 12 }}>
          <CarouselComponent />
        </Grid2>
        <Grid2 item size={{ md: 3, sm: 4, xs: 12 }}>
          <NormalContainerWithHeader >
            <LingtBlueContainer>
              <DarkBlueContainer>
                <Icon icon="game-icons:piggy-bank" color='#4169E1' width="40px" height="40px" />
              </DarkBlueContainer>
              <Typography variant='body1' fontWeight={500} color='blue.main' mt={1}>My Piggy Bank</Typography>
              {!isCreditScoreLoading &&
                <Typography variant='body2' fontWeight={500} color='blue.main'>
                  {creditScore?.data?.credits_scored_count}
                </Typography>
              }
              {
                isCreditScoreLoading && <TextSkeleton />
              }


            </LingtBlueContainer>
            <Box mt={2}>

              <Button

                style={{ borderRadius: "15px" }}
                variant="contained" startIcon={<AddIcon />} fullWidth onClick={() => {
                  showToaster(
                    'We Are Working On this Functionality',
                    'Currently Unavailable',
                    'warning'
                  );
                }}>
                Request for Refund
              </Button>
            </Box>

          </NormalContainerWithHeader>
        </Grid2>
      </Grid2>
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"Today's Classes"} isGrid={false}>
        <StudentClasses isLoading={isCourseLoading} courses={allCourses} />
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <Memories />
      <CustomDivider orientation='horizontal' />
      <EventSection />
      <CustomDivider orientation='horizontal' />

    </>
  );
};

export default Dashboard;
